<template>
  <i
    v-if="variant === 'dot'"
    class="inline-block h-1.5 w-1.5 rounded-full bg-orange-500 ring-1 ring-white"
    :title="title"
    data-testid="pre-allocation-badge-dot"
  />
  <span
    v-else
    class="inline-flex items-center rounded border border-orange-300 bg-orange-50 px-1 text-[10px] font-bold leading-4 text-orange-700"
    :title="title"
    data-testid="pre-allocation-badge"
  >
    Pré-alocado
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { PreAllocationTag } from '@/types/qualification-eligibility.types'

import { preAllocationTitle } from './qualificationText'

/** `dot` para as células compactas da grade (só o ponto, com o mesmo título). */
const props = withDefaults(defineProps<{ tag: PreAllocationTag; variant?: 'pill' | 'dot' }>(), {
  variant: 'pill'
})

const title = computed(() => preAllocationTitle(props.tag))
</script>
